import React, { useEffect, useState } from "react"

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
  CardTitle,
} from "reactstrap"
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { AddNewUser, getAllUsers, getUserById } from "../../store/actions"
// import { getByClientId } from "../../store/actions";
import { useParams } from "react-router-dom"
import PageLoader from '../../components/Common/PageLoader';
import SelectSearch from "react-select-search";
import { userFormResetFieldTouched } from "constants/ResetFormField"
import Select, { createFilter } from "react-select";

const UserForm = props => {
  const [selectedGroup, setselectedGroup] = useState(null)
  let { id } = useParams()
  const [clientCodeValue, setClientCodeValue] = useState(null);
  const [userData, setUserData] = useState(null)
  document.title = `${!id ? "Add New User" : "Update User"} | Glottis Logistics`

  const dispatch = useDispatch()

  // Form validation
  const userForm = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      clientCode: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Enter first name").max(30, 'First name should not exceed 30 characters'),
      lastName: Yup.string().required("Enter last name").max(30, 'Last name should not exceed 30 characters'),
      email: Yup.string().email('Enter valid email address').required("Enter email address").max(30, 'Email address should not exceed 30 characters'),
      phoneNumber: Yup.string().required("Enter phone number").max(15, 'Phone number should not exceed 15 characters'),
      clientCode: Yup.string().required('Select client')
    }),
    onSubmit: (values, { resetForm }) => {
      if (id) {
        dispatch(AddNewUser(values, props.history, id))
      } else {
        dispatch(AddNewUser(values, props.history))
      }
      dispatch(getAllUsers())
    },
  })
  const getUserData = () => {
    dispatch(getUserById(id))
  }
  const { user } = useSelector(state => ({
    user: state.GetUserById.user,
  }))

  useEffect(() => {
    if (id) {
      getUserData()
    }
  }, [id])
  useEffect(() => {
    setUserData(user)
  }, [user])

  function setRoleValue(clientCodeValue) {
    setselectedGroup(clientCodeValue);
    userForm.setFieldValue("clientCode", clientCodeValue);
  }

  useEffect(() => {
    setFormValues()
  }, [userData])
  const loading = useSelector(state => ({
    loaderstatus: state.AddUser.loading
  }))
  const client = useSelector(state => ({
    client: state?.Clients?.client
  }))
  const clientCodeList = client?.client?.map((client) => ({
    label: client.name + " (" + client.clientCode + ")",
    value: client.clientCode,
  }));

  const listOfClientCode = clientCodeList && [{ label: "Select client code", value: "" }, ...clientCodeList]

  function setClientCode(data) {
    const value = { label: data, value: data }
    setClientCodeValue(value);
    userForm.setFieldValue("clientCode", data);
  }

  const setFormValues = () => {
    if (id && user) {
      userForm.setFieldValue("firstName", user.firstName)
      userForm.setFieldValue("lastName", user.lastName)
      userForm.setFieldValue("email", user.email)
      userForm.setFieldValue("phoneNumber", user.phoneNumber)
      setClientCode(user.clientCode)
    }
  }

  return (
    <React.Fragment>
      {loading.loaderstatus ? <PageLoader /> :""}
        <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Users" dashurl="/users" breadcrumbItem={!id ? "Add New User" : "Update User"}
          />
          <Card color="info" className="text-white-50">
            <CardBody>
              <CardTitle className="m-0 text-white">
                <i className="mdi mdi-alert-circle-outline me-3" />After sucessful creation of account, login credential will be sent to email address of this account.
              </CardTitle>
            </CardBody>
          </Card>
          <Row>
              <Col xl="12">
                <Form
                  className="needs-validation"
                  onSubmit={e => {
                    e.preventDefault()
                    userForm.handleSubmit()
                    return false
                  }}
                >
                  <Card>
                    <CardBody>
                      <Row>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>Client code <span>*</span></Label>
                            <div className={`position-relative drop-down ${userForm.touched.clientCode && userForm.errors.clientCode ? 'role' : ''}`}>
                            <Select
                              options={listOfClientCode}
                              className={`form-control`}
                              search={true} 
                              name="clientCode"
                              filterOption={createFilter({matchFrom : 'start'})}
                              value={clientCodeValue}
                              placeholder={`Select clientCode`}
                              onChange={(value) => {
                                setClientCode(value.value);
                              }}
                            />
                          </div> 
                            {userForm.touched.clientCode && userForm.errors.clientCode ? (
                              <span className="role-error invalid-feedback">{userForm.errors.clientCode}</span>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>First name <span>*</span></Label>
                            <Input
                              name="firstName"
                              type="text"
                              className="form-control"
                              onChange={userForm.handleChange}
                              onBlur={userForm.handleBlur}
                              value={userForm.values.firstName || ""}
                              invalid={
                                userForm.touched.firstName &&
                                  userForm.errors.firstName
                                  ? true
                                  : false
                              }
                            />
                            {userForm.touched.firstName &&
                              userForm.errors.firstName ? (
                              <FormFeedback type="invalid">
                                {userForm.errors.firstName}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>Last name <span>*</span></Label>
                            <Input
                              name="lastName"
                              type="text"
                              className="form-control"
                              id="validationCustom01"
                              onChange={userForm.handleChange}
                              onBlur={userForm.handleBlur}
                              value={userForm.values.lastName || ""}
                              invalid={
                                userForm.touched.lastName &&
                                  userForm.errors.lastName
                                  ? true
                                  : false
                              }
                            />
                            {userForm.touched.lastName &&
                              userForm.errors.lastName ? (
                              <FormFeedback type="invalid">
                                {userForm.errors.lastName}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>Email address <span>*</span></Label>
                            <Input
                              name="email"
                              type="text"
                              className="form-control"
                              onChange={userForm.handleChange}
                              onBlur={userForm.handleBlur}
                              value={userForm.values.email || ""}
                              invalid={
                                userForm.touched.email && userForm.errors.email
                                  ? true
                                  : false
                              }
                            />
                            {userForm.touched.email && userForm.errors.email ? (
                              <FormFeedback type="invalid">
                                {userForm.errors.email}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>

                        <Col md="4">
                          <FormGroup className="mb-3">
                            <Label>Phone number <span>*</span></Label>
                            <Input
                              name="phoneNumber"
                              onWheel={(e) => e.target.blur()}
                              type='number'
                              className="form-control"
                              onChange={userForm.handleChange}
                              onBlur={userForm.handleBlur}
                              value={userForm.values.phoneNumber || ""}
                              invalid={
                                userForm.touched.phoneNumber &&
                                  userForm.errors.phoneNumber
                                  ? true
                                  : false
                              }
                            />
                            {userForm.touched.phoneNumber &&
                              userForm.errors.phoneNumber ? (
                              <FormFeedback type="invalid">
                                {userForm.errors.phoneNumber}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody >
                  </Card >
                    <div className="mb-30">
                      <button className="primary-button" type="submit">
                        Save
                      </button>
                      <button type="reset" onClick={() => {
                        if (id) {
                          setFormValues()
                          userFormResetFieldTouched(false, userForm)
                        } else {
                          userForm.resetForm()
                          setselectedGroup(undefined)
                          setClientCodeValue(null)
                        }
                      }} className="ms-4 secountry-btn">
                        Clear
                      </button>
                    </div>
                </Form >
              </Col >
            </Row >
          </Container >
        </div >
    
     
    </React.Fragment >
  )
}

export default UserForm
